// Subscription Bundle for product page 
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const mainATC = document.querySelector('#main_atc');
    const customATC = document.querySelector('.custom-atc');
    const subBundleOptions = document.querySelectorAll('.quantity-break__container input[name="subscription"]');
    const productsToAdd = [];

    // Store variant IDs in JS 
    const FREE_PRODUCTS = {
      ebook: parseInt(document.querySelector('.addon_wrapper .ebook')?.dataset.id || 0),
      mystery: parseInt(document.querySelector('.addon_wrapper .mystery_box')?.dataset.id || 0),
      warranty: parseInt(document.querySelector('.addon_wrapper .warranty')?.dataset.id || 0)
    };

    function findQuantity() {
      const selectedOption = document.querySelector('.quantity-break__container input[name="subscription"]:checked');
      return selectedOption ? parseInt(selectedOption.dataset.quantity || '0') : 0;
    }

    function buildAddon() {
      productsToAdd.length = 0;
      const quantity = findQuantity();

      // Decide which free items to add based on quantity
      if (quantity >= 4) {
        productsToAdd.push({ id: FREE_PRODUCTS.ebook, quantity: 1 });
      }
      if (quantity >= 6) {
        productsToAdd.push({ id: FREE_PRODUCTS.mystery, quantity: 1 });
      }
      if (quantity >= 8) {
        productsToAdd.push({ id: FREE_PRODUCTS.warranty, quantity: 1 });
      }
    }

    if(subBundleOptions.length > 0) {
      subBundleOptions.forEach(option => {
        option.addEventListener('change', (e) => {
          buildAddon();
        });
      });
    }

    customATC?.addEventListener('click', function() {
      this.classList.add('loading');
      if (productsToAdd.length === 0) {
        mainATC?.click();
        this.classList.remove('loading');
        return;
      }

      // Send each item one by one using AJAX
      fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: productsToAdd })
        })
        .then(res => res.json())
        .then(() => {
          mainATC?.click();
          setTimeout(() => {
            customATC.classList.remove('loading');
          },500);
        })
        .catch(err => {
          console.error("Error adding gift products:", err);
          alert("Something went wrong. Please try again.");
          customATC.classList.add('loading');
        });
    });

    // initial call
    buildAddon();
  }, 500);
})
